import lottie from 'lottie-web'

class SpaLottie {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
    
  }

  bindUI() {
    this.ui = {}
    this.animations = new Map() // Map pour stocker les animations par overlay
    this.currentAnimationId = null
    this.isProcessing = false
    this.isInitialOverlay = true // Flag pour détecter l'ouverture initiale
  }

  bindEvents() {
    
    // Écouter l'ouverture de l'overlay
    window.addEventListener('overlay:opened', this.onOverlayOpened.bind(this))
    
    // Écouter la fermeture de l'overlay
    window.addEventListener('overlay:closed', this.onOverlayClosed.bind(this))
    
    // Attendre que le slider soit disponible
    this.waitForSlider()
  }

  waitForSlider() {
    const checkSlider = () => {
      if (window.sliderdefault) {
        console.log('SpaLottie: Attachement initial de slideChange');
        window.sliderdefault.on('slideChange', this.onSlideChange.bind(this))
      } else {
        setTimeout(checkSlider, 100)
      }
    }
    checkSlider()
  }

  onOverlayOpened(event) {
    
    // Marquer que c'est l'ouverture initiale
    this.isInitialOverlay = true

    // Afficher un loader simple
    this.showSpaLottieLoader()
    
    // Attendre que le slider soit complètement initialisé
    this.waitForSliderReady(() => {
      // (ré)attacher l'écouteur slideChange à chaque ouverture
      if (window.sliderdefault) {
        if (window.sliderdefault.off) {
          window.sliderdefault.off('slideChange', this.onSlideChange.bind(this));
        }
        console.log('SpaLottie: (Ré)attachement de slideChange à l\'ouverture overlay');
        window.sliderdefault.on('slideChange', this.onSlideChange.bind(this));
      } else {
        console.warn('SpaLottie: Pas de sliderdefault lors de l\'ouverture overlay');
      }
      this.initSpaLottie()
      // Retirer le loader après initialisation
      this.hideSpaLottieLoader()
    })
  }

  onOverlayClosed() {
    this.cleanupAllAnimations()
    this.resetAllOverlays()
    // Réinitialiser le flag
    this.isInitialOverlay = true
  }

  onSlideChange() {
    console.log('SpaLottie: onSlideChange appelé', window.sliderdefault && window.sliderdefault.activeIndex);
    
    // Marquer que ce n'est plus l'ouverture initiale
    this.isInitialOverlay = false
    
    // Nettoyer l'animation actuelle seulement
    this.cleanupCurrentAnimation()
    
    // Cacher immédiatement tous les overlays Lottie lors des changements de slide
    this.hideAllLottieOverlays()
    
    // --- AJOUT : Nettoyage strict de la slide active ---
    const activeSlide = window.sliderdefault && window.sliderdefault.slides
      ? window.sliderdefault.slides[window.sliderdefault.activeIndex]
      : null;
    if (activeSlide && activeSlide.classList.contains('template-spa')) {
      console.log('SpaLottie: nettoyage overlay sur swipe', activeSlide);
      const overlay = activeSlide.querySelector('.js-spa-lottie-overlay');
      if (overlay) {
        overlay.classList.add('is-hidden');
        const container = overlay.querySelector('.js-spa-lottie-container');
        if (container) {
          container.innerHTML = '';
        }
      }
      const slideContent = activeSlide.querySelector('.js-overlay-child');
      if (slideContent) {
        slideContent.style.opacity = '1';
        slideContent.style.visibility = 'visible';
        slideContent.style.transition = 'none';
        setTimeout(() => {
          slideContent.style.transition = '';
        }, 100);
      }
    }
    // ---------------------------------------------------
    
    // Ne pas traiter la nouvelle slide - l'overlay doit rester caché
    // this.processSlideChange()
  }

  processSlideChange() {
    // Vérifier si on est déjà en train de traiter
    if (this.isProcessing) {
      return
    }
    
    this.isProcessing = true
    
    // Délai adaptatif basé sur l'état du slider
    const delay = window.sliderdefault && window.sliderdefault.isBeginning ? 50 : 150
    
    setTimeout(() => {
      this.initSpaLottie()
      this.isProcessing = false
    }, delay)
  }

  hideAllLottieOverlays() {
    const allOverlays = document.querySelectorAll('.js-spa-lottie-overlay')
    allOverlays.forEach(overlay => {
      // Cacher immédiatement l'overlay
      overlay.classList.add('is-hidden')
      
      // Afficher directement le contenu de la slide sans transition
      const slide = overlay.closest('.swiper-slide')
      if (slide && slide.classList.contains('template-spa')) {
        const slideContent = slide.querySelector('.js-overlay-child')
        if (slideContent) {
          slideContent.style.opacity = '1'
          slideContent.style.visibility = 'visible'
          slideContent.style.transition = 'none' // Désactiver les transitions pour éviter les glitches
          
          // Réactiver les transitions après un court délai
          setTimeout(() => {
            slideContent.style.transition = ''
          }, 100)
        }
      }
    })
  }

  cleanupAllAnimations() {
    
    // Nettoyer les animations actives
    this.animations.forEach((animationData, id) => {
      if (animationData.animation && animationData.animation.destroy) {
        animationData.animation.destroy()
      }
    })
    this.animations.clear()
    
    // Réinitialiser l'ID courant
    this.currentAnimationId = null
  }

  cleanupCurrentAnimation() {
    if (this.currentAnimationId && this.animations.has(this.currentAnimationId)) {
      const animationData = this.animations.get(this.currentAnimationId)
      if (animationData.animation && animationData.animation.destroy) {
        animationData.animation.destroy()
      }
      this.animations.delete(this.currentAnimationId)
      this.currentAnimationId = null
    }
  }

  resetAllOverlays() {
    const allOverlays = document.querySelectorAll('.js-spa-lottie-overlay')
    allOverlays.forEach(overlay => {
      this.resetOverlay(overlay)
    })
  }

  resetOverlay(overlay) {
    // Rendre l'overlay visible
    overlay.classList.remove('is-hidden')
    
    // Nettoyer le conteneur
    const container = overlay.querySelector('.js-spa-lottie-container')
    if (container) {
      container.innerHTML = ''
    }
    
    // Masquer le contenu de la slide
    const slide = overlay.closest('.swiper-slide')
    if (slide && slide.classList.contains('template-spa')) {
      const slideContent = slide.querySelector('.js-overlay-child')
      if (slideContent) {
        slideContent.style.opacity = '0'
        slideContent.style.visibility = 'hidden'
      }
    }
  }

  waitForSliderReady(callback) {
    const checkReady = () => {
      if (window.sliderdefault && window.sliderdefault.slides && window.sliderdefault.slides.length > 0) {
        const activeSlide = window.sliderdefault.slides[window.sliderdefault.activeIndex]
        if (activeSlide) {
          console.log('SpaLottie: Slider is ready')
          callback()
          return
        }
      }
      setTimeout(checkReady, 50)
    }
    checkReady()
  }

  initSpaLottie() {
    console.log('SpaLottie: initSpaLottie called')
    
    // Nettoyer l'animation précédente
    this.cleanupCurrentAnimation()
    
    // Chercher l'overlay Lottie dans la slide active
    const activeSlide = window.sliderdefault.slides[window.sliderdefault.activeIndex]
    if (!activeSlide) {
      return
    }
    
    // Vérifier si la slide active est un template spa
    if (!activeSlide.classList.contains('template-spa')) {
      return
    }
    
    const overlay = activeSlide.querySelector('.js-spa-lottie-overlay')
    if (!overlay) {
      return
    }
    
    
    // Si ce n'est pas l'ouverture initiale, ne rien faire (l'overlay est déjà caché)
    if (!this.isInitialOverlay) {
      console.log('SpaLottie: Not initial overlay, overlay already hidden')
      return
    }
    
    // Sinon, traiter l'animation normalement
    this.processOverlay(overlay)
  }

  showContentDirectly(overlay) {
    
    // S'assurer que l'overlay est caché immédiatement
    overlay.classList.add('is-hidden')
    
    // Afficher directement le contenu de la slide
    const slide = overlay.closest('.swiper-slide')
    if (slide && slide.classList.contains('template-spa')) {
      const slideContent = slide.querySelector('.js-overlay-child')
      if (slideContent) {
        // Appliquer les styles immédiatement pour éviter le glitch
        slideContent.style.opacity = '1'
        slideContent.style.visibility = 'visible'
        slideContent.style.transition = 'none' // Désactiver les transitions temporairement
        
        // Réactiver les transitions après un court délai
        setTimeout(() => {
          slideContent.style.transition = ''
        }, 50)
      }
    }
  }

  processOverlay(overlay) {
    // S'assurer que l'overlay est visible
    overlay.classList.remove('is-hidden')
    
    const container = overlay.querySelector('.js-spa-lottie-container')
    if (!container) {
      this.hideSpaLottie(overlay)
      return
    }

    const path = container.getAttribute('data-path')
    if (!path) {
      this.hideSpaLottie(overlay)
      return
    }

    // Vérifier si une animation est déjà en cours pour ce conteneur
    if (container.querySelector('svg')) {
      return
    }

    // Nettoyer le conteneur
    container.innerHTML = ''
    this.createNewAnimation(container, path, overlay)
  }

  createNewAnimation(container, path, overlay) {
    // Créer une nouvelle animation
    const animation = lottie.loadAnimation({
      container: container,
      renderer: 'svg',
      loop: false,
      speed: 1.15,
      autoplay: false,
      path: path
    })

    this.setupAnimation(animation, overlay)
  }

  setupAnimation(animation, overlay) {
    const animationId = Date.now() + Math.random()
    this.currentAnimationId = animationId
    
    // Stocker l'animation
    this.animations.set(animationId, {
      animation: animation,
      overlay: overlay,
      isComplete: false,
      isError: false,
      startTime: Date.now()
    })

    // Variables pour tracker l'état
    let animationComplete = false
    let animationError = false

    // Lancer l'animation immédiatement
    animation.addEventListener('data_ready', () => {
      animation.play()
    })

    animation.addEventListener('complete', () => {
      if (!animationComplete) {
        animationComplete = true
        this.animations.get(animationId).isComplete = true
        this.finishAnimation(overlay, animationId)
      }
    })

    animation.addEventListener('error', (error) => {
      console.error('SpaLottie: Animation error:', error)
      if (!animationError) {
        animationError = true
        this.animations.get(animationId).isError = true
        setTimeout(() => {
          this.finishAnimation(overlay, animationId)
        }, 1000)
      }
    })

    // Vérification périodique de l'état de l'animation
    const checkAnimationState = () => {
      if (animationComplete || animationError) {
        return
      }
      
      // Vérifier si l'animation est vraiment terminée
      if (animation && animation.isLoaded && animation.totalFrames) {
        const currentFrame = animation.currentFrame
        const totalFrames = animation.totalFrames
        
        if (currentFrame >= totalFrames - 1) {
          animationComplete = true
          this.animations.get(animationId).isComplete = true
          this.finishAnimation(overlay, animationId)
          return
        }
      }
      
      // Continuer la vérification
      setTimeout(checkAnimationState, 100)
    }
    
    // Démarrer la vérification après un délai
    setTimeout(checkAnimationState, 500)

    // Fallback de sécurité : cacher après 5 secondes maximum
    setTimeout(() => {
      if (!animationComplete && !animationError) {
        console.log('SpaLottie: Animation fallback timeout - forcing completion')
        animationComplete = true
        this.finishAnimation(overlay, animationId)
      }
    }, 5000)
  }

  finishAnimation(overlay, animationId) {
    const animationData = this.animations.get(animationId)
    if (animationData && !animationData.processed) {
      animationData.processed = true
      console.log('SpaLottie: Finishing animation for overlay')
      this.hideSpaLottie(overlay)
      this.revealSlideContent(overlay.closest('.swiper-slide'))
    }
  }

  revealSlideContent(slide) {
    if (slide && slide.classList.contains('template-spa')) {
      const slideContent = slide.querySelector('.js-overlay-child')
      if (slideContent) {
        slideContent.style.opacity = '1'
        slideContent.style.visibility = 'visible'
        console.log('SpaLottie: Content revealed')
      }
    }
  }

  hideSpaLottie(overlay) {
    console.log('SpaLottie: Hiding overlay')
    overlay.classList.add('is-hidden')
  }



  // Méthode pour forcer la réinitialisation complète (utile en cas de problème)
  forceReset() {
    console.log('SpaLottie: Force reset called')
    this.cleanupAllAnimations()
    this.resetAllOverlays()
    this.isProcessing = false
    this.currentAnimationId = null
    this.isInitialOverlay = true

  }

  showSpaLottieLoader() {
    // Crée un loader simple si pas déjà présent
    if (!document.querySelector('.spa-lottie-loader')) {
      const loader = document.createElement('div')
      loader.className = 'spa-lottie-loader'
      loader.innerHTML = '<div class="spa-lottie-loader__spinner"></div>'
      document.body.appendChild(loader)
    }
  }

  hideSpaLottieLoader() {
    const loader = document.querySelector('.spa-lottie-loader')
    if (loader) loader.remove()
  }
}

export default SpaLottie 